import "core-js/modules/es.object.assign.js";
import { getUserEmailPrefix } from './_weblogger';
import { sendImmediatelyCustom } from './weblogerEvent';
var _uploadAPITime = function _uploadAPITime(options) {
  try {
    sendImmediatelyCustom('web_api_time', options);
  } catch (e) {}
};
function getPubParams() {
  return {
    user_email: getUserEmailPrefix()
  };
}
export var uploadAPITime = function uploadAPITime(options) {
  var params = Object.assign({}, getPubParams(), options);
  _uploadAPITime(params);
};